// src/components/Navbar.jsx
import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./navbar.css";

export default function Navbar({ SVGs }) {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar" style={{position: 'static'}}>
      {/* Logo + toggle */}
      <div className="navbar-top">


        {/* redirect to home page */}
        <Link to="/" className="navbar-home-link">
          <img
            src={SVGs.womenlogo}
            alt="IIT Delhi Logo"
            className="navbar-logo"
          />
        </Link>

        {/* Mobile toggle (hamburger) */}
        <button
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="navbar-toggle"
        >
          <svg
            className={`toggle-icon ${open ? "rotate" : ""}`}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            {open ? (
              <path strokeLinecap="round" d="M6 6l12 12M18 6L6 18" />
            ) : (
              <>
                <path strokeLinecap="round" d="M3 6h18" />
                <path strokeLinecap="round" d="M3 12h18" />
                <path strokeLinecap="round" d="M3 18h18" />
              </>
            )}
          </svg>
        </button>
      </div>

      {/* Desktop links */}
      <div className="navbar-links desktop">
        <NavLink to="/womenmeet/" className="nav-link">About IWFM</NavLink>
        <NavLink to="/womenmeet/committee" className="nav-link">Committee</NavLink>
        <NavLink to="/womenmeet/speakers" className="nav-link">Keynote Speaker</NavLink>
        <NavLink to="/womenmeet/meeting" className="nav-link">Meeting</NavLink>
        <NavLink to="/womenmeet/contact" className="nav-link">Contact</NavLink>
      </div>

      {/* Mobile dropdown */}
      <div className={`navbar-links mobile ${open ? "open" : ""}`}>
        <NavLink onClick={() => setOpen(false)} to="/womenmeet/" className="nav-link">
          About IWFM
        </NavLink>
        <NavLink onClick={() => setOpen(false)} to="/womenmeet/committee" className="nav-link">
          Committee
        </NavLink>
        <NavLink onClick={() => setOpen(false)} to="/womenmeet/speakers" className="nav-link">
          Keynote Speaker
        </NavLink>
        <NavLink onClick={() => setOpen(false)} to="/womenmeet/meeting" className="nav-link">
          Meeting
        </NavLink>
        <NavLink onClick={() => setOpen(false)} to="/womenmeet/contact" className="nav-link">
          Contact
        </NavLink>
      </div>
    </nav>
  );
}
